import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyLinearHoldIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.5 21C20.776 21 21 20.776 21 20.5V3.5C21 3.224 20.776 3 20.5 3H12.175C12.049 3 11.927 3.048 11.835 3.134L2.644 11.676C2.548 11.765 2.5 11.883 2.5 12C2.5 12.117 2.548 12.234 2.644 12.324L11.834 20.866C11.927 20.952 12.048 21 12.174 21H20.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyLinearHoldIcon.displayName = 'TimeDkeyLinearHoldIcon';
